import {format} from 'date-fns';
import {combine, merge, sample} from 'effector';

import {createGate} from 'effector-react';

import {showRestError} from '@app/errors';
import {rootDomain} from '@app/model';
import {DATE_REQUEST_PATTERN} from '@consts/date';
import {dateModel as date} from '@entities/date/model';
import {Summary, SummaryCounts} from '@entities/summary/types';

import {userModel} from '@entities/user/model';

import * as api from './api';

const domain = rootDomain.createDomain('Summary');

export const SummaryGate = createGate('Summary');

const fetchDataFx = domain.createEffect({handler: api.fetch});
const data$ = domain.createStore<Summary | null>(null);
fetchDataFx.failData.watch(showRestError);

const fetchCountsFx = domain.createEffect({handler: api.fetchCounts});
const counts$ = domain.createStore<SummaryCounts | null>(null);
fetchCountsFx.failData.watch(showRestError);

data$.on(fetchDataFx.doneData, (_, data) => data);
counts$.on(fetchCountsFx.doneData, (_, data) => data);

sample({
    clock: merge([SummaryGate.open, date.changed]),
    source: combine({
        tin: userModel.state.map((s) => s.profile?.company.tin ?? ''),
        date: date.state,
    }),
    filter: SummaryGate.status,
    fn: ({tin, date}) => ({
        ...(tin && {tin}),
        ...(date.range.from && {dateFrom: format(date.range.from, DATE_REQUEST_PATTERN)}),
        ...(date.range.to && {dateTo: format(date.range.to, DATE_REQUEST_PATTERN)}),
    }),
    target: [fetchDataFx, fetchCountsFx],
});

const $summaryState = combine({
    data: data$,
    counts: counts$,
    pending: fetchDataFx.pending,
});

export const summaryModel = {
    state: $summaryState,
};
